import { Theme } from '@constants';

export const LDL = {
  paddingLeft: Theme.px(48),
  height: Theme.px(60),
  timeLogoWidth: Theme.px(180),
  logoWidth: Theme.px(60),
  timeWidth: Theme.px(180 - 60),
  contentWidth: Theme.px(1920 - (48 + 180)),
};
